import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import Brand from '../components/Brand';
import { Mail, Lock, ArrowRight } from 'lucide-react';

export default function LoginPage() {
  const { login, loading } = useAuthStore();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState(null);
  const loc = useLocation(); const nav = useNavigate();
  const from = loc.state?.from?.pathname || '/dashboard';

  const submit = async (e) => {
    e.preventDefault(); setErr(null);
    try { await login(email, password); nav(from, { replace: true }); }
    catch (e) { setErr(e.message); }
  };

  return (
    <div className="min-h-screen bg-ee-bg flex flex-col">
      <div className="p-6"><Brand /></div>
      <div className="flex-1 flex items-center justify-center px-4">
        <div className="w-full max-w-md">
          <div className="text-center mb-8">
            <h1 className="hero-title text-4xl text-white mb-2">Welcome back</h1>
            <p className="text-ee-muted">Sign in to continue your journey</p>
          </div>
          <form onSubmit={submit} className="ee-card p-8 space-y-4">
            <label className="block">
              <span className="text-xs uppercase tracking-wider text-gold/80">Email</span>
              <div className="mt-1 flex items-center gap-2 bg-ee-bg border border-ee-border rounded-md px-3 focus-within:border-gold transition-colors">
                <Mail size={16} className="text-ee-muted" />
                <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="flex-1 bg-transparent py-3 outline-none text-white text-sm" placeholder="you@example.com" />
              </div>
            </label>
            <label className="block">
              <span className="text-xs uppercase tracking-wider text-gold/80">Password</span>
              <div className="mt-1 flex items-center gap-2 bg-ee-bg border border-ee-border rounded-md px-3 focus-within:border-gold transition-colors">
                <Lock size={16} className="text-ee-muted" />
                <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="flex-1 bg-transparent py-3 outline-none text-white text-sm" placeholder="••••••••" />
              </div>
            </label>
            {err && <div className="text-sm text-red-400 bg-red-400/10 border border-red-400/30 rounded-md p-2">{err}</div>}
            <button data-testid="login-submit" type="submit" disabled={loading} className="w-full flex items-center justify-center gap-2 py-3 rounded-md gold-grad text-black font-semibold disabled:opacity-50 hover:-translate-y-0.5 transition-all">
              {loading ? 'Signing in…' : <>Sign In <ArrowRight size={16} /></>}
            </button>
            <div className="text-center text-sm text-ee-muted">
              No account? <Link to="/register" className="text-gold hover:underline">Create one</Link>
            </div>
          </form>
          <div className="text-center mt-6 text-xs text-ee-dim">Admin? <Link to="/admin/login" className="text-gold hover:underline">Sign in to Control Center</Link></div>
        </div>
      </div>
    </div>
  );
}
